import React from 'react'
import styled from 'styled-components'
import { breakpointUpTo } from 'utils/breakpoints'

const MAX_CONTENT_WIDTH = 1608

const PADDINGS = {
  xs: 24,
  md: 72,
  lg: 144,
}

const MAX_WIDTH = MAX_CONTENT_WIDTH + 2 * PADDINGS.lg

const StyledWrapper = styled.div`
  max-width: ${MAX_WIDTH}px;
  margin-left: auto;
  margin-right: auto;
  padding-left: ${PADDINGS.lg}px;
  padding-right: ${PADDINGS.lg}px;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    padding-left: ${PADDINGS.md}px;
    padding-right: ${PADDINGS.md}px;
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    padding-left: ${PADDINGS.xs}px;
    padding-right: ${PADDINGS.xs}px;
  }
`

type LayoutContentWrapperProps = {
  children: React.ReactNode
  className?: string
}

export const LayoutContentWrapper = ({
  children,
  className,
}: LayoutContentWrapperProps) => {
  return <StyledWrapper className={className}>{children}</StyledWrapper>
}
